import { IVendor, IVendorRequest, TVendorRequest } from '../model/IVendor';
import api from './api';

export const vendorApi = api.injectEndpoints({
  endpoints: (build) => ({
    getVendorList: build.query<IVendor[], void>({
      query: () => ({
        url: 'vendors',
      }),
      providesTags: ['Vendors'],
    }),

    getVendor: build.query<IVendor, string>({
      query: (vendorId) => ({
        url: `vendors/${vendorId}`,
      }),
      providesTags: ['Vendor'],
    }),

    addVendor: build.mutation<IVendor, IVendorRequest>({
      query: (body) => ({
        url: 'vendors',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Vendors'],
    }),

    editVendor: build.mutation<IVendor, TVendorRequest>({
      query: ({ id, ...body }) => ({
        url: `vendors/${id}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Vendors', 'Vendor'],
    }),

    deleteVendor: build.mutation<unknown, IVendor['id']>({
      query: (id) => ({
        url: `vendors/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Vendors', 'Vendor'],
    }),
  }),
});
